// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"0292f6ad","383":"aa81c293","412":"38297d34","541":"1adee4bb","586":"ad836e79","610":"05ee8543","631":"021b8d00","813":"f2668457","840":"8151f9a0"}[chunkId] + ".chunk.js";
};